export enum TransactionTypeFilter {
  Credit = 'credit',
  Debit = 'debit',
}
